let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("gcdWg")).then(() => parcelRequire('kXP2Z'));